import React, { Component } from 'react';
import EmptyMapPlaceholder from './../../../../assets/placeholders/empty_map.svg';

class EmptyMap extends Component {
  state = {  }
  
  render() { 
    let mappingType = "";
    const {mapType} = this.props;
    if(mapType === "Map to job category"){
      mappingType = "Job Category"
    }else{
      mappingType = "Occupations"
    }
    return ( 
      <div className="text-center">
        <img src={EmptyMapPlaceholder}/>
        <div className="mt30" 
          style={{lineHeight:'34px',fontSize:'18px',color:'#54555F'}}>
          Looks like you haven’t matched any columns to map {mappingType}. If you wish to do so, 
          you can go back and match columns or you can continue. 
        </div>
      </div>
    );
  }
}
 
export default EmptyMap;